export default class TitleFromIdNumber {
  determineTitle(idNumber, maleValue, femaleValue) {
    if (idNumber){
      return idNumber.slice(6, 10) >= 5000 ? maleValue : femaleValue;
    }
  }
}
